const pack = {
  "zhcn": {
    "loading":'加载中',
    "P_YS_PF_GZTLOG_0000083159": "详细数据",
    "P_YS_PF_GZTLOG_0000083158": "对比操作",
    "P_YS_PF_GZTLOG_0000083157": "无法查询历史，请指定id对应字段。",
    "P_YS_PF_GZTLOG_0000083156": "业务历史变更",
    "P_YS_FED_EXAMP_0000019871": "删除",
    "P_YS_HR_HRRCPDF_0000058793": "对比",
    "P_YS_FED_FW_0000022188": "更新",
    "P_YS_PF_GZTLOG_0000080579": "没有详细数据，请检查数据上是否存在",
    "P_YS_PF_GZTLOG_0000080576": "查看数据",
    "P_YS_PF_GZTPRE_0000071075": "未知日期",
    "P_YS_FED_FW_0000021020": "新增",
    "P_YS_PF_GZTLOG_0001068839": "关闭"
  },
  "enus": {
    "loading":'Loading',
    "P_YS_PF_GZTLOG_0000083159": "Detail Data",
    "P_YS_PF_GZTLOG_0000083158": "Compare",
    "P_YS_PF_GZTLOG_0000083157": "Unable to query history, please specify ID field.",
    "P_YS_PF_GZTLOG_0000083156": "Business History",
    "P_YS_FED_FW_0000021020": "New",
    "P_YS_PF_GZTLOG_0000080576": "view",
    "P_YS_PF_GZTLOG_0000080579": "Please check if the data exists",
    "P_YS_FED_FW_0000022188": "Update",
    "P_YS_PF_GZTPRE_0000071075": "Unknown date",
    "P_YS_FED_EXAMP_0000019871": "Delete",
    "P_YS_HR_HRRCPDF_0000058793": "Compare",
    "P_YS_PF_GZTLOG_0001068839": "Close"
  },
  "zhtw": {
    "loading":'加載中',
    "P_YS_PF_GZTLOG_0000083159": "詳細數據",
    "P_YS_PF_GZTLOG_0000083158": "對比操作",
    "P_YS_PF_GZTLOG_0000083157": "無法查詢歷史，請指定id對應字段。",
    "P_YS_PF_GZTLOG_0000083156": "業務歷史變更",
    "P_YS_FED_EXAMP_0000019871": "刪除",
    "P_YS_HR_HRRCPDF_0000058793": "對比",
    "P_YS_FED_FW_0000022188": "更新",
    "P_YS_PF_GZTLOG_0000080579": "沒有詳細數據，請檢查數據上是否存在",
    "P_YS_PF_GZTLOG_0000080576": "查看數據",
    "P_YS_PF_GZTPRE_0000071075": "未知日期",
    "P_YS_FED_FW_0000021020": "新增",
    "P_YS_PF_GZTLOG_0001068839": "關閉"
  }
}

export default pack;


// WEBPACK FOOTER //
// ./src/languages/pack.js